export enum SHADOWS {
  xs = "0px 0px 1px 1px rgba(0, 0, 0, 0.03)",
  sm = "0px 1px 4px 1px rgba(0, 0, 0, 0.05)",
  md = "0px -1px 8px -3px rgba(0, 0, 0, 0.3), 0px 5px 8px -3px rgba(0, 0, 0, 0.3);",
  lg = "0px 4px 20px -5px rgba(0, 0, 0, 0.08), 0px 4px 20px -5px rgba(0, 0, 0, 0.08);",
  base = "0px 1px 7px 0px rgba(0, 0, 0, 0.05)",
  xl = "0px 3px 0.938rem -5px rgba(0, 0, 0, 0.4);",
  "2xl" = "2px 2px 10px -5px rgba(0, 0, 0, 0.4);",
  outline = "0px 0px 5px 3px rgba(229, 229, 234, 0.5);",
  inner = "0px 2px 6px 0px rgba(0, 0, 0, 0.08) inset;",
  "dark-lg" = "0px -5px 0.938rem -0.1875rem rgba(0, 0, 0, 0.06);",
}
